/**
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import {
  createBuiltManuscriptViewerPanelFromFiles,
  deriveLeafId,
} from "@csk/demo-ui/components/manuscript-viewer";

const FILES = import.meta.glob<string>(
  "../../../../../../theory/manuscripts/contrib/TwoCategoricalCSK/*.md",
  { query: "?raw", import: "default", eager: true },
);

export const ManuscriptPanel = createBuiltManuscriptViewerPanelFromFiles(
  {
    id: "two-categorical-csk-manuscript",
    label: "Manuscript",
    eyebrow: "TWO-CATEGORICAL CSK · MANUSCRIPT",
    deriveId: deriveLeafId,
    isAppendix: () => false,
  },
  FILES,
  {
    unavailablePath: "theory/manuscripts/contrib/TwoCategoricalCSK/.",
  },
);
